import { useQuery } from '@apollo/client';
import { getBuildingIdItems } from '@/components/global-search/utils';
import { GET_BUILDINGS_BY_IDS } from '@/graphql/StatusQuoAnalysis.queries';

export const isPrediumIdQuery = (query: string) => /^\d+$/.test(query.trim());

export function useSearchBuildingId(searchText: string) {
  const isNumeric = isPrediumIdQuery(searchText);

  const { data, loading, error } = useQuery(GET_BUILDINGS_BY_IDS, {
    variables: { ids: isNumeric ? [Number(searchText.trim())] : [] },
    skip: !isNumeric,
    fetchPolicy: 'cache-and-network',
  });

  return {
    buildingIds: getBuildingIdItems(isNumeric ? (data?.building ?? []) : []),
    loading,
    error,
  };
}
